import { InputBase } from "@mui/material";
import styled from "styled-components";

const StyledInputBase = styled(InputBase)({
  "& input": {
    width: "240px",
  },
  // مخفی کردن آیکون پیش‌فرض مرورگر در Edge/Chrome
  '& input[type="password"]::-ms-reveal': {
    display: "none",
  },
  '& input[type="password"]::-ms-clear': {
    display: "none",
  },
  // برای Chrome, Safari, جدیدترها
  '& input[type="password"]::-webkit-contacts-auto-fill-button': {
    visibility: "hidden",
    display: "none",
    pointerEvents: "none",
    position: "absolute",
    right: 0,
  },
});

export const StyledInputBaseFullWidth = styled(InputBase)({
  // مخفی کردن آیکون پیش‌فرض مرورگر در Edge/Chrome
  '& input[type="password"]::-ms-reveal': {
    display: "none",
  },
  '& input[type="password"]::-ms-clear': {
    display: "none",
  },
  // برای Chrome, Safari, جدیدترها
  '& input[type="password"]::-webkit-contacts-auto-fill-button': {
    visibility: "hidden",
    display: "none",
    pointerEvents: "none",
    position: "absolute",
    right: 0,
  },
});

export default StyledInputBase;
